import DropdownMenu from "@/common/components/DropdownMenu"
import { BillResumeData } from "../types/bills.type";
import { useState } from "react";
import BillRemoveFailureModal from "./Actions/RemoveFailureModal";
import BillRemoveCompanyRejectionModal from "./Actions/RemoveCompanyRejectionModal";

interface BillHeaderDropdownActionsProps {
  bill: BillResumeData | undefined;
}

const BillHeaderDropdownActions = ({ bill }: BillHeaderDropdownActionsProps) => {
  const [removeFailureModalIsOpen, setRemoveFailureModalIsOpen] = useState(false);
  const [removeCompanyRejectionModalIsOpen, setRemoveCompanyRejectionModalIsOpen] = useState(false);

  const shouldDisplayRemoveFailureButton = bill?.accepted_by_service_at && bill?.rejected_by_service_at;
  const shouldDisplayRemoveCompanyRejection = bill?.status === 'rejected_by_company' || bill?.rejected_by_company_reason;

  if (![
    shouldDisplayRemoveFailureButton,
    shouldDisplayRemoveCompanyRejection,
  ].some(Boolean)) {
    return null;
  }

  return (
    <>
      <DropdownMenu
        triggerLabel='Ações'
        dataTestId="bill_actions_dropdown_trigger"
        options={[
          ...(shouldDisplayRemoveFailureButton ? [{
            label: "Marcar falha como resolvida",
            onClick: () => setRemoveFailureModalIsOpen(true),
            operationKlassToCheckPermission: "Admin::Billing::Bills::RemoveFailure",
            dataTestId: "remove_failure_button",
          }] : []),
          ...(shouldDisplayRemoveCompanyRejection ? [{
            label: "Remover rejeição da empresa",
            onClick: () => setRemoveCompanyRejectionModalIsOpen(true),
            operationKlassToCheckPermission: "Admin::Billing::Bills::RemoveCompanyRejection",
            dataTestId: "remove_company_rejection",
          }] : []),
        ]}
        menuPositionAlign="end"
      />

      <BillRemoveFailureModal
        billId={bill?.id}
        isOpen={removeFailureModalIsOpen}
        setIsOpen={setRemoveFailureModalIsOpen}
      />

      <BillRemoveCompanyRejectionModal
        billId={bill?.id}
        isOpen={removeCompanyRejectionModalIsOpen}
        setIsOpen={setRemoveCompanyRejectionModalIsOpen}
      />
    </>
  );
}

export default BillHeaderDropdownActions;
